import React from 'react';

interface ChevronIconProps {
    className?: string;
    fill?: string;
    rotate?: boolean;
}

const ChevronIcon: React.FC<ChevronIconProps> = ({
    className = 'h-3 w-3',
    fill = 'currentColor',
    rotate = false
}) => {
    const rotateClass = rotate ? 'rotate-180' : '';
    const combinedClassName = `${className} ${rotateClass}`.trim();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={combinedClassName}
            viewBox="0 0 20 20"
            fill={fill}
        >
            <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default ChevronIcon;
